module.exports = __webpack_public_path__ + "static/datature-logo-8d69280f7871c936fa7c2ac9aa96bebd.png";